import { Dialog, DialogBody, DialogTitle, EditProps } from '@/components/base/dialog'
import { EditPackageQuery } from './__generated__/edit_query'
import { Query } from './edit_query'
import { AdjustmentsHorizontalIcon, CubeIcon, CurrencyPoundIcon, DocumentIcon, PencilIcon, PhotoIcon, VariableIcon } from '@heroicons/react/24/solid'
import { Tabs } from '@/components/tabs'
import { Form as DetailsForm } from './edit_form'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'
import { EditImages } from './edit_images'
import { EditPackageAssetType } from './edit_package_asset_type'
import { EditCategories } from './edit_categories'
import { EditSpecifications } from './edit_specifications'
import { EditMultipliers } from './edit_multipliers'
import { EditCustomFields } from './edit_custom_fields'
import { EditAttachments } from './edit_attachments'
import { EditDocuments } from './edit_documents'

export const EditDialog = ({ id, open, setOpen }: EditProps) => {
  const tabs = [
    { name: 'Details', component: <DetailsForm id={id} />, icon: PencilIcon },
    { name: 'Asset types', component: <EditPackageAssetType id={id} />, icon: PencilIcon },
    { name: 'Images', component: <EditImages id={id} />, icon: PhotoIcon },
    { name: 'Attachments', component: <EditAttachments id={id} />, icon: DocumentIcon },
    { name: 'Categories', component: <EditCategories id={id} />, icon: CubeIcon },
    { name: 'Specifications', component: <EditSpecifications id={id} />, icon: AdjustmentsHorizontalIcon },
    { name: 'Multipliers', component: <EditMultipliers id={id} />, icon: CurrencyPoundIcon },
    { name: 'Custom fields', component: <EditCustomFields id={id} />, icon: VariableIcon },
    { name: 'Documents', component: <EditDocuments id={id} />, icon: DocumentIcon },
  ]

  const { data, loading } = useQuery<EditPackageQuery>(Query, { variables: { filters: { idEq: id } } })

  return (
    <>
      <Dialog open={open} size="5xl" onClose={setOpen}>
        <DialogTitle><div>{ loading || !data ? <Loading /> : data.packages.nodes[0].name }</div></DialogTitle>
        <DialogBody>
          <Tabs tabs={tabs} />
        </DialogBody>
      </Dialog>
    </>
  )
}
